import Vue from "vue";

Vue.filter("smallerCents", (str: any, noCurrency?: boolean) => {
    if (str) {
        if (!isNumber(str) || noCurrency) {
            return str;
        }
        let i: any = str.indexOf(".");
        let splits: any = [str.substr(0, i), str.splice(i + 1, i + 3), str.splice(i + 3)];
        return splits[0] + ".<sup class='decimal-cents'>" + splits[1] + " </sup>" + splits[2];
    }
});

function isNumber(n: any) {
    return !isNaN(parseFloat(n));
}